export default {
  STATS: "stats",
  NO_STATS: "no_stats",
  ADVANCED_STATS: "advanced_stats",
};
